export default "__VITE_ASSET__DWo2tnve__"